module.exports = __webpack_public_path__ + "img/logo_login.c1c2809e.png";